var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel centered"},[_c('p',[_vm._v(_vm._s(_vm.t("Your subscription has expired. In order to view the plan, you will need to renew your subscription.")))]),_c('label',[_c('button',{staticClass:"btn submit",on:{"click":_vm.trySubmit}},[_vm._v(_vm._s(_vm.t('Renew Now')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }